const initialState = {
    franchiseManagers: [],
    pagination: {},
    projectList: [],
    localityList: [],
    localityListLoading: false,
    projectListLoading: false,
    franchiseManagerDetail: null,
    detailLoading: false,
    accessControlUpdating: false,
    siteVisits: [],
    siteVisitPagination: {},
    siteVisitDetail: null,
    homeVisits: [],
    homeVisitPagination: {},
    homeVisitDetail: null,
    visitLoading: false,
    visitDetailLoading: false,
    loading: false,
    error: null,
};

export const franchiseManagerReducer = (state = initialState, action) => {
    switch (action.type) {
        case "FRANCHISE_MANAGER_LIST_REQUEST":
            return { ...state, loading: true, error: null };

        case "FRANCHISE_MANAGER_LIST_SUCCESS":
            return {
                ...state,
                loading: false,
                franchiseManagers: action.payload.data?.data || [],
                pagination: action.payload.data?.pagination || {},
                error: null,
            };

        case "FRANCHISE_MANAGER_LIST_FAIL":
            return { ...state, loading: false, error: action.payload };

        case "FRANCHISE_MANAGER_ADD_REQUEST":
            return { ...state, loading: true, error: null };

        case "FRANCHISE_MANAGER_ADD_SUCCESS":
            return { ...state, loading: false, error: null };

        case "FRANCHISE_MANAGER_ADD_FAIL":
            return { ...state, loading: false, error: action.payload };

        case "FRANCHISE_MANAGER_PROJECT_LIST_REQUEST":
            return { ...state, projectListLoading: true, error: null };

        case "FRANCHISE_MANAGER_PROJECT_LIST_SUCCESS":
            return {
                ...state,
                projectListLoading: false,
                projectList: action.payload.data || [],
                error: null,
            };

        case "FRANCHISE_MANAGER_PROJECT_LIST_FAIL":
            return { ...state, projectListLoading: false, error: action.payload };

        case "FRANCHISE_MANAGER_LOCALITY_LIST_REQUEST":
            return { ...state, localityListLoading: true, error: null };

        case "FRANCHISE_MANAGER_LOCALITY_LIST_SUCCESS":
            return {
                ...state,
                localityListLoading: false,
                localityList: action.payload.data || [],
                error: null,
            };

        case "FRANCHISE_MANAGER_LOCALITY_LIST_FAIL":
            return { ...state, localityListLoading: false, error: action.payload };

        case "FRANCHISE_MANAGER_DETAIL_REQUEST":
            return { ...state, detailLoading: true, franchiseManagerDetail: null, error: null };

        case "FRANCHISE_MANAGER_DETAIL_SUCCESS":
            return {
                ...state,
                detailLoading: false,
                franchiseManagerDetail: action.payload.data || null,
                error: null,
            };

        case "FRANCHISE_MANAGER_DETAIL_FAIL":
            return { ...state, detailLoading: false, error: action.payload };

        case "FRANCHISE_MANAGER_EDIT_REQUEST":
            return { ...state, loading: true, error: null };

        case "FRANCHISE_MANAGER_EDIT_SUCCESS":
            return { ...state, loading: false, error: null };

        case "FRANCHISE_MANAGER_EDIT_FAIL":
            return { ...state, loading: false, error: action.payload };

        case "FRANCHISE_MANAGER_CHANGE_STATUS_REQUEST":
            return { ...state, statusUpdating: true, error: null };

        case "FRANCHISE_MANAGER_CHANGE_STATUS_SUCCESS":
            return {
                ...state,
                statusUpdating: false,
                franchiseManagerDetail:
                    state.franchiseManagerDetail &&
                        state.franchiseManagerDetail._id === action.payload.id
                        ? { ...state.franchiseManagerDetail, status: action.payload.status }
                        : state.franchiseManagerDetail,
                franchiseManagers: state.franchiseManagers.map((fm) =>
                    fm._id === action.payload.id ? { ...fm, status: action.payload.status } : fm
                ),
                error: null,
            };

        case "FRANCHISE_MANAGER_CHANGE_STATUS_FAIL":
            return { ...state, statusUpdating: false, error: action.payload };

        case "FRANCHISE_MANAGER_DOCUMENT_STATUS_REQUEST":
            return { ...state, documentStatusUpdating: true, error: null };

        case "FRANCHISE_MANAGER_DOCUMENT_STATUS_SUCCESS":
            return {
                ...state,
                documentStatusUpdating: false,
                franchiseManagerDetail:
                    state.franchiseManagerDetail &&
                        state.franchiseManagerDetail._id === action.payload.id
                        ? {
                            ...state.franchiseManagerDetail,
                            document_verification_status: action.payload.approval,
                            document_rejection_reason: action.payload.reason,
                        }
                        : state.franchiseManagerDetail,
                franchiseManagers: state.franchiseManagers.map((fm) =>
                    fm._id === action.payload.id
                        ? {
                            ...fm,
                            document_verification_status: action.payload.approval,
                            document_rejection_reason: action.payload.reason,
                        }
                        : fm
                ),
                error: null,
            };

        case "FRANCHISE_MANAGER_DOCUMENT_STATUS_FAIL":
            return { ...state, documentStatusUpdating: false, error: action.payload };

        case "FRANCHISE_MANAGER_CITY_LIST_REQUEST":
            return { ...state, cityListLoading: true, error: null };

        case "FRANCHISE_MANAGER_CITY_LIST_SUCCESS":
            return {
                ...state,
                cityListLoading: false,
                cityList: action.payload.data || [],
                error: null,
            };

        case "FRANCHISE_MANAGER_CITY_LIST_FAIL":
            return { ...state, cityListLoading: false, error: action.payload };

        case "FRANCHISE_MANAGER_ACCESS_CONTROL_REQUEST":
            return { ...state, accessControlUpdating: true, error: null };

        case "FRANCHISE_MANAGER_ACCESS_CONTROL_SUCCESS":
            return {
                ...state,
                accessControlUpdating: false,
                franchiseManagerDetail:
                    state.franchiseManagerDetail &&
                        state.franchiseManagerDetail._id === action.payload.data?._id
                        ? { ...state.franchiseManagerDetail, access_control: action.payload.data.access_control }
                        : state.franchiseManagerDetail,
                franchiseManagers: state.franchiseManagers.map((fm) =>
                    fm._id === action.payload.data?._id
                        ? { ...fm, access_control: action.payload.data.access_control }
                        : fm
                ),
                error: null,
            };

        case "FRANCHISE_MANAGER_ACCESS_CONTROL_FAIL":
            return { ...state, accessControlUpdating: false, error: action.payload };

        case "FRANCHISE_MANAGER_CITY_HEADS_REQUEST":
            return { ...state, cityHeadsLoading: true, error: null };

        case "FRANCHISE_MANAGER_CITY_HEADS_SUCCESS":
            return {
                ...state,
                cityHeadsLoading: false,
                cityHeads: action.payload.data || [],
                error: null,
            };

        case "FRANCHISE_MANAGER_CITY_HEADS_FAIL":
            return { ...state, cityHeadsLoading: false, error: action.payload };

        case "FRANCHISE_CITY_HEAD_ADD_REQUEST":
            return { ...state, cityHeadAdding: true, error: null };

        case "FRANCHISE_CITY_HEAD_ADD_SUCCESS":
            return { ...state, cityHeadAdding: false, error: null };

        case "FRANCHISE_CITY_HEAD_ADD_FAIL":
            return { ...state, cityHeadAdding: false, error: action.payload };

        case "FRANCHISE_CITY_HEAD_EDIT_REQUEST":
            return { ...state, cityHeadEditing: true, error: null };

        case "FRANCHISE_CITY_HEAD_EDIT_SUCCESS":
            return { ...state, cityHeadEditing: false, error: null };

        case "FRANCHISE_CITY_HEAD_EDIT_FAIL":
            return { ...state, cityHeadEditing: false, error: action.payload };

        case "FRANCHISE_LOCALITY_HEAD_ADD_REQUEST":
            return { ...state, localityHeadAdding: true, error: null };
        case "FRANCHISE_LOCALITY_HEAD_ADD_SUCCESS":
            return { ...state, localityHeadAdding: false, error: null };
        case "FRANCHISE_LOCALITY_HEAD_ADD_FAIL":
            return { ...state, localityHeadAdding: false, error: action.payload };

        case "FRANCHISE_LOCALITY_HEAD_EDIT_REQUEST":
            return { ...state, localityHeadEditing: true, error: null };
        case "FRANCHISE_LOCALITY_HEAD_EDIT_SUCCESS":
            return { ...state, localityHeadEditing: false, error: null };
        case "FRANCHISE_LOCALITY_HEAD_EDIT_FAIL":
            return { ...state, localityHeadEditing: false, error: action.payload };

        case "FRANCHISE_MANAGER_LOCALITY_HEADS_REQUEST":
            return { ...state, localityHeadsLoading: true, error: null };

        case "FRANCHISE_MANAGER_LOCALITY_HEADS_SUCCESS":
            return {
                ...state,
                localityHeadsLoading: false,
                localityHeads: action.payload.data || [],
                error: null,
            };

        case "FRANCHISE_MANAGER_LOCALITY_HEADS_FAIL":
            return { ...state, localityHeadsLoading: false, error: action.payload };

        case "LIST_PARTNERS_BY_HIERARCHY_REQUEST":
            return {
                ...state,
                partnersByHierarchyLoading: true,
                error: null,
            };

        case "LIST_PARTNERS_BY_HIERARCHY_SUCCESS":
            return {
                ...state,
                partnersByHierarchyLoading: false,
                partnersByHierarchy: action.payload.data || [],
                error: null,
            };

        case "LIST_PARTNERS_BY_HIERARCHY_FAILED":
            return {
                ...state,
                partnersByHierarchyLoading: false,
                partnersByHierarchy: [],
                error: action.payload,
            };

        case "SITE_VISIT_LIST_REQUEST":
            return { ...state, visitLoading: true, error: null };
        case "SITE_VISIT_LIST_SUCCESS":
            return {
                ...state,
                visitLoading: false,
                siteVisits: action.payload.data?.data || [],
                siteVisitPagination: action.payload.data?.pagination || {},
                error: null,
            };
        case "SITE_VISIT_LIST_FAIL":
            return { ...state, visitLoading: false, error: action.payload };

        case "SITE_VISIT_DETAIL_REQUEST":
            return { ...state, visitDetailLoading: true, siteVisitDetail: null, error: null };
        case "SITE_VISIT_DETAIL_SUCCESS":
            return { ...state, visitDetailLoading: false, siteVisitDetail: action.payload.data || null, error: null };
        case "SITE_VISIT_DETAIL_FAIL":
            return { ...state, visitDetailLoading: false, error: action.payload };

        case "HOME_VISIT_LIST_REQUEST":
            return { ...state, visitLoading: true, error: null };
        case "HOME_VISIT_LIST_SUCCESS":
            return {
                ...state,
                visitLoading: false,
                homeVisits: action.payload.data?.data || [],
                homeVisitPagination: action.payload.data?.pagination || {},
                error: null,
            };
        case "HOME_VISIT_LIST_FAIL":
            return { ...state, visitLoading: false, error: action.payload };

        case "HOME_VISIT_DETAIL_REQUEST":
            return { ...state, visitDetailLoading: true, homeVisitDetail: null, error: null };
        case "HOME_VISIT_DETAIL_SUCCESS":
            return { ...state, visitDetailLoading: false, homeVisitDetail: action.payload.data || null, error: null };
        case "HOME_VISIT_DETAIL_FAIL":
            return { ...state, visitDetailLoading: false, error: action.payload };

        case "FRANCHISE_MANAGER_ACCESS_CONTROL_DELETE_REQUEST":
            return { ...state, accessControlUpdating: true, error: null };

        case "FRANCHISE_MANAGER_ACCESS_CONTROL_DELETE_SUCCESS":
            return {
                ...state,
                accessControlUpdating: false,
                franchiseManagerDetail:
                    state.franchiseManagerDetail &&
                        state.franchiseManagerDetail._id === action.payload.data?._id
                        ? { ...state.franchiseManagerDetail, access_control: action.payload.data.access_control }
                        : state.franchiseManagerDetail,
                franchiseManagers: state.franchiseManagers.map((fm) =>
                    fm._id === action.payload.data?._id
                        ? { ...fm, access_control: action.payload.data.access_control }
                        : fm
                ),
                error: null,
            };

        case "FRANCHISE_MANAGER_ACCESS_CONTROL_DELETE_FAIL":
            return { ...state, accessControlUpdating: false, error: action.payload };
            
        default:
            return state;
    }
};